<template>
  <div>
    <HeroInner descrition="Disparo de Emails" class="mt-70" />

    <div class="grid-box">
      <v-layout bg-white ma-4 mt-5 column br-4>
        <div class="my-donations-header">
          <div>
            <Icon name="fal fa-envelope title-icon" size="32" colorFont="#C3C6D5" />
            <h2>Disparo de Emails</h2>
          </div>
          <div>
            <InputText type="search" place-holder="Buscar..." :showLoader="false" v-model="search" />
          </div>
        </div>

        <div
          style="display: flex !important; justify-content: flex-end; padding: 14px 32px; border-bottom: 1px solid #eceef4; background: #fafbfd;"
        >
          <button
            type="button"
            @click="openCreate"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: #3c9c8e; color: #fff; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 600; font-family: inherit;"
          >
            <i class="fal fa-plus"></i>
            <span>Novo Dispatch</span>
          </button>
        </div>

        <v-data-table
          :headers="headers"
          :items="filteredDispatches"
          :loading="loading"
          locale="pt_BR"
          :disable-pagination="true"
          hide-actions
          hide-default-footer
          class="text-xs-left ma-4"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <b>{{ props.item.name }}</b>
              </td>
              <td>
                <v-chip small label color="grey lighten-3">{{ props.item.slug }}</v-chip>
              </td>
              <td>
                <span class="dispatch-description">{{ props.item.description || "—" }}</span>
              </td>
              <td class="text-xs-center">
                <v-chip small label color="primary" outlined>
                  {{ (props.item.variables && props.item.variables.length) || 0 }}
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-switch
                  v-model="props.item.isActive"
                  color="green"
                  :loading="props.item.toggling"
                  :disabled="props.item.toggling"
                  @change="toggleActive(props.item)"
                  hide-details
                  class="mt-0"
                ></v-switch>
              </td>
              <td class="text-xs-center">
                <v-btn icon flat @click="openEdit(props.item)" :title="'Editar'">
                  <i class="fal fa-edit"></i>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </div>

    <!-- Modal de edição -->
    <v-dialog v-model="editDialog" persistent max-width="960">
      <v-card v-if="editing">
        <v-card-title>
          <div>
            <h3>{{ isCreating ? 'Novo disparo' : 'Editar disparo' }}</h3>
            <small v-if="!isCreating">
              <v-chip small label color="grey lighten-3">{{ editing.slug }}</v-chip>
              <b class="ml-2">{{ editing.name }}</b>
            </small>
          </div>
        </v-card-title>

        <v-card-text class="edit-modal-content">
          <div class="edit-modal-inner">
          <div v-if="isCreating" class="field-group">
            <label>Nome</label>
            <input
              type="text"
              v-model="editing.name"
              placeholder="Ex: Confirmação de Doação"
              class="plain-input"
            />
          </div>

          <div v-if="isCreating" class="field-group">
            <label>Slug</label>
            <input
              type="text"
              v-model="editing.slug"
              placeholder="Ex: donation_confirmed (apenas letras minúsculas e underscore)"
              class="plain-input"
            />
            <small style="display:block; color:#666; font-size:11px; margin-top:4px;">
              Identificador único do dispatch. Depois de criado não pode ser alterado.
            </small>
          </div>

          <div class="field-group">
            <label>Descrição</label>
            <textarea
              v-model="editing.description"
              rows="2"
              placeholder="Breve descrição de quando esse e-mail é disparado"
              class="plain-input plain-textarea"
            ></textarea>
          </div>

          <div class="variables-header">
            <h4>Variáveis disponíveis para o template</h4>
          </div>

          <div class="variables-hint">
            As variáveis abaixo estarão disponíveis no editor de template do AUC Captação para esse disparo.
            A chave (<code v-text="keyPlaceholder"></code>) não pode ser alterada depois de criada para não quebrar templates existentes.
          </div>

          <div class="variables-list">
            <div
              v-for="(variable, index) in editing.variables"
              :key="variable.id || `new-${index}`"
              class="variable-card"
            >
              <div class="variable-card-header">
                <div class="variable-card-title">
                  <span v-if="variable.key" class="variable-card-key">{{ variable.key }}</span>
                  <span v-else class="variable-card-new">Nova variável</span>
                </div>
                <button
                  type="button"
                  class="variable-remove-btn"
                  @click="removeVariable(index)"
                  title="Remover"
                >
                  <i class="fal fa-trash"></i>
                </button>
              </div>

              <div class="variable-card-body">
                <div class="variable-grid">
                  <div class="variable-field key-field">
                    <label>Chave</label>
                    <input
                      type="text"
                      v-model="variable.key"
                      :disabled="!!variable.id"
                      :placeholder="'cartId'"
                      class="plain-input"
                      @focus="showKeySuggestions(index, $event)"
                      @blur="onKeyBlur(index)"
                      @input="showKeySuggestions(index, $event)"
                      autocomplete="off"
                    />
                  </div>

                  <div class="variable-field">
                    <label>Rótulo</label>
                    <input
                      type="text"
                      v-model="variable.label"
                      placeholder="ID do carrinho"
                      class="plain-input"
                    />
                  </div>

                  <div class="variable-field">
                    <label>Tipo</label>
                    <select v-model="variable.dataType" class="plain-input">
                      <option
                        v-for="opt in dataTypeOptions"
                        :key="opt.value"
                        :value="opt.value"
                      >{{ opt.text }}</option>
                    </select>
                  </div>

                  <div class="variable-field variable-field-check">
                    <label>Obrigatória</label>
                    <label class="checkbox-wrapper">
                      <input type="checkbox" v-model="variable.isRequired" />
                      <span>Sim</span>
                    </label>
                  </div>
                </div>

                <div class="variable-field variable-field-full">
                  <label>Descrição</label>
                  <input
                    type="text"
                    v-model="variable.description"
                    placeholder="Explica o que essa variável representa"
                    class="plain-input"
                  />
                </div>

                <div class="variable-field variable-field-full">
                  <label>Valor de exemplo</label>
                  <input
                    type="text"
                    v-model="variable.sampleValue"
                    placeholder="Ex: 5678"
                    class="plain-input"
                  />
                </div>
              </div>
            </div>

            <button
              type="button"
              class="variable-add-card"
              @click="addVariable"
            >
              <i class="fal fa-plus"></i>
              <span>Adicionar variável</span>
            </button>
          </div>

          <div v-if="!editing.variables || editing.variables.length === 0" class="empty-variables">
            Nenhuma variável cadastrada. Clique em "Adicionar variável" acima para criar a primeira.
          </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeEdit" :disabled="saving">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEdit">Salvar</v-btn>
        </v-card-actions>

        <!-- Dropdown de sugestões (posicionado via fixed pra escapar overflow) -->
        <div
          v-if="activeKeyIndex !== null && editing && editing.variables && editing.variables[activeKeyIndex] && !editing.variables[activeKeyIndex].id && filteredSuggestions(editing.variables[activeKeyIndex].key).length > 0"
          class="key-suggestions-floating"
          :style="suggestionsStyle"
        >
          <div class="suggestions-hint">
            {{ filteredSuggestions(editing.variables[activeKeyIndex].key).length }} sugestão(ões) — clique para aplicar
          </div>
          <div class="suggestions-list">
            <div
              v-for="suggestion in filteredSuggestions(editing.variables[activeKeyIndex].key)"
              :key="suggestion.key"
              class="suggestion-item"
              @mousedown.prevent="applySuggestion(activeKeyIndex, suggestion)"
            >
              <div class="suggestion-main">
                <code class="suggestion-key">{{ suggestion.key }}</code>
                <span class="suggestion-type">{{ dataTypeLabel(suggestion.dataType) }}</span>
              </div>
              <div class="suggestion-label">{{ suggestion.label }}</div>
              <div class="suggestion-usedin">
                Usado em <b>{{ suggestion.usedIn.length }}</b>
                {{ suggestion.usedIn.length === 1 ? 'dispatch' : 'dispatches' }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HeroInner from "@/components/HeroInner.vue";
import Icon from "@/components/Icon.vue";
import InputText from "@/components/input/InputText.vue";
import EmailDispatchConfigService from "@/scripts/services/emailDispatchConfig.service";

export default {
  components: {
    HeroInner,
    Icon,
    InputText,
  },
  data() {
    return {
      service: new EmailDispatchConfigService(),
      dispatches: [],
      search: "",
      loading: false,
      headers: [
        { text: "Nome", value: "name", sortable: true },
        { text: "Slug", value: "slug", sortable: true },
        { text: "Descrição", value: "description", sortable: false },
        { text: "Variáveis", value: "variablesCount", sortable: false, align: "center", width: "120px" },
        { text: "Ativo", value: "isActive", sortable: true, align: "center", width: "120px" },
        { text: "", value: "actions", sortable: false, align: "center", width: "80px" },
      ],
      editDialog: false,
      editing: null,
      isCreating: false,
      saving: false,
      activeKeyIndex: null,
      suggestionsStyle: {},
      dataTypeOptions: [
        { text: "Texto", value: "string" },
        { text: "Inteiro", value: "int" },
        { text: "Número", value: "number" },
        { text: "Data", value: "date" },
        { text: "URL", value: "url" },
        { text: "Booleano", value: "boolean" },
        { text: "HTML", value: "html" },
      ],
      keyPlaceholder: "{{key}}",
    };
  },
  computed: {
    filteredDispatches() {
      if (!this.search) return this.dispatches;
      const s = this.search.toLowerCase();
      return this.dispatches.filter(
        (d) =>
          d.name.toLowerCase().includes(s) ||
          d.slug.toLowerCase().includes(s) ||
          (d.description && d.description.toLowerCase().includes(s))
      );
    },
    /**
     * Agrega todas as variáveis únicas (por `key`) entre todos os dispatches.
     * Cada entrada guarda o primeiro registro encontrado (para label, tipo, sample)
     * + a lista de slugs de dispatches que já usam essa key.
     */
    knownKeysMap() {
      const map = new Map();
      for (const d of this.dispatches) {
        const vars = d.variables || [];
        for (const v of vars) {
          if (!v.key) continue;
          if (!map.has(v.key)) {
            map.set(v.key, {
              key: v.key,
              label: v.label || "",
              description: v.description || "",
              dataType: v.dataType || "string",
              sampleValue: v.sampleValue || "",
              usedIn: [d.slug],
            });
          } else {
            const entry = map.get(v.key);
            if (!entry.usedIn.includes(d.slug)) entry.usedIn.push(d.slug);
          }
        }
      }
      return map;
    },
  },
  created() {
    this.loadDispatches();
  },
  methods: {
    loadDispatches() {
      this.loading = true;
      this.service
        .listWithVariables()
        .then((data) => {
          this.dispatches = (data || []).map((d) => ({ ...d, toggling: false }));
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    toggleActive(item) {
      item.toggling = true;
      this.service
        .toggleActive(item.id)
        .then((data) => {
          item.isActive = data.isActive;
          item.toggling = false;
        })
        .catch(() => {
          item.isActive = !item.isActive;
          item.toggling = false;
        });
    },
    openEdit(item) {
      this.editing = {
        id: item.id,
        name: item.name,
        slug: item.slug,
        description: item.description || "",
        variables: (item.variables || []).map((v) => ({ ...v })),
      };
      this.isCreating = false;
      this.editDialog = true;
    },
    openCreate() {
      this.editing = {
        id: null,
        name: "",
        slug: "",
        description: "",
        variables: [],
      };
      this.isCreating = true;
      this.editDialog = true;
    },
    closeEdit() {
      this.editDialog = false;
      this.editing = null;
      this.isCreating = false;
    },
    addVariable() {
      if (!this.editing.variables) this.editing.variables = [];
      this.editing.variables.push({
        key: "",
        label: "",
        description: "",
        dataType: "string",
        isRequired: false,
        sampleValue: "",
      });
    },
    removeVariable(index) {
      this.editing.variables.splice(index, 1);
    },
    dataTypeLabel(value) {
      const found = this.dataTypeOptions.find((o) => o.value === value);
      return found ? found.text : value;
    },
    filteredSuggestions(query) {
      const all = Array.from(this.knownKeysMap.values());
      // keys já usadas NESTE dispatch que está sendo editado (pra não sugerir duplicata)
      const alreadyUsed = new Set(
        (this.editing?.variables || [])
          .map((v) => (v.key || "").trim())
          .filter(Boolean)
      );
      const available = all.filter((k) => !alreadyUsed.has(k.key));
      // Excluir a própria key da variável (senão mostra sugestão repetida quando tá digitando)
      const selfKey = ((query || "").trim());
      if (!selfKey) {
        return available;
      }
      const q = selfKey.toLowerCase();
      return available.filter(
        (k) =>
          k.key.toLowerCase().includes(q) ||
          (k.label && k.label.toLowerCase().includes(q))
      );
    },
    showKeySuggestions(index, event) {
      this.activeKeyIndex = index;
      this.$nextTick(() => {
        const el = event?.target || null;
        if (!el) return;
        const rect = el.getBoundingClientRect();

        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const preferredHeight = 360;
        const gap = 4;

        // Decide se abre pra baixo ou pra cima
        // - Se cabe pelo menos 200px abaixo, abre pra baixo
        // - Senão, se tem mais espaço acima, abre pra cima
        if (spaceBelow >= Math.min(preferredHeight, 200) || spaceBelow >= spaceAbove) {
          const maxH = Math.max(160, Math.min(preferredHeight, spaceBelow - 12));
          this.suggestionsStyle = {
            top: (rect.bottom + gap) + "px",
            left: rect.left + "px",
            width: rect.width + "px",
            maxHeight: maxH + "px",
          };
        } else {
          const maxH = Math.max(160, Math.min(preferredHeight, spaceAbove - 12));
          this.suggestionsStyle = {
            bottom: (viewportHeight - rect.top + gap) + "px",
            left: rect.left + "px",
            width: rect.width + "px",
            maxHeight: maxH + "px",
          };
        }
      });
    },
    applySuggestion(index, suggestion) {
      const variable = this.editing.variables[index];
      if (!variable) return;
      variable.key = suggestion.key;
      // Só sobrescreve os outros campos se estiverem vazios (evita apagar
      // valores que o usuário já tenha começado a digitar).
      if (!variable.label) variable.label = suggestion.label;
      if (!variable.description) variable.description = suggestion.description;
      if (!variable.dataType || variable.dataType === "string")
        variable.dataType = suggestion.dataType;
      if (!variable.sampleValue) variable.sampleValue = suggestion.sampleValue;
      this.activeKeyIndex = null;
    },
    onKeyBlur(index) {
      // Timeout pra permitir que o mousedown no item da lista dispare antes
      setTimeout(() => {
        if (this.activeKeyIndex === index) this.activeKeyIndex = null;
      }, 150);
    },
    saveEdit() {
      if (this.isCreating) {
        if (!this.editing.name || !this.editing.name.trim()) {
          this.$store.commit("SET_SNACKBAR_MESSAGE", "O nome é obrigatório.");
          return;
        }
        if (!this.editing.slug || !this.editing.slug.trim()) {
          this.$store.commit("SET_SNACKBAR_MESSAGE", "O slug é obrigatório.");
          return;
        }
        if (!/^[a-z0-9_]+$/.test(this.editing.slug.trim())) {
          this.$store.commit(
            "SET_SNACKBAR_MESSAGE",
            "O slug deve conter apenas letras minúsculas, números e underscore."
          );
          return;
        }
      }

      const invalidKey = (this.editing.variables || []).find(
        (v) => !v.key || !v.key.trim() || !v.label || !v.label.trim()
      );
      if (invalidKey) {
        this.$store.commit(
          "SET_SNACKBAR_MESSAGE",
          "Todas as variáveis precisam ter chave e rótulo preenchidos."
        );
        return;
      }

      const keys = (this.editing.variables || []).map((v) => v.key.trim());
      const hasDuplicate = keys.some((k, i) => keys.indexOf(k) !== i);
      if (hasDuplicate) {
        this.$store.commit(
          "SET_SNACKBAR_MESSAGE",
          "Existem variáveis com a mesma chave. As chaves devem ser únicas."
        );
        return;
      }

      this.saving = true;
      // emailDispatchConfigId é setado pelo backend no ReplaceVariablesForDispatch;
      // não precisa (e não deve) vir do frontend — principalmente no modo criação
      // quando o dispatch ainda não tem id.
      const variablesPayload = (this.editing.variables || []).map((v) => ({
        id: v.id,
        key: v.key.trim(),
        label: v.label.trim(),
        description: v.description,
        dataType: v.dataType || "string",
        isRequired: !!v.isRequired,
        sampleValue: v.sampleValue,
      }));

      if (this.isCreating) {
        const payload = {
          name: this.editing.name.trim(),
          slug: this.editing.slug.trim().toLowerCase(),
          description: this.editing.description,
          isActive: true,
          variables: variablesPayload,
        };
        this.service
          .create(payload)
          .then((data) => {
            this.dispatches.push({ ...data, toggling: false });
            this.saving = false;
            this.closeEdit();
          })
          .catch(() => {
            this.saving = false;
          });
      } else {
        const payload = {
          description: this.editing.description,
          variables: variablesPayload,
        };
        this.service
          .update(this.editing.id, payload)
          .then((data) => {
            const idx = this.dispatches.findIndex((d) => d.id === this.editing.id);
            if (idx >= 0) {
              this.dispatches.splice(idx, 1, { ...data, toggling: false });
            }
            this.saving = false;
            this.closeEdit();
          })
          .catch(() => {
            this.saving = false;
          });
      }
    },
  },
};
</script>

<style scoped>
/* Resetar display do conteúdo interno do modal para empilhamento vertical */
.edit-modal-content {
  padding: 16px !important;
}

.edit-modal-inner {
  display: block !important;
  width: 100% !important;
}

.edit-modal-inner > * {
  display: block !important;
  width: 100% !important;
  flex: none !important;
}

.edit-modal-inner .variables-list > * {
  display: block !important;
  width: 100% !important;
  flex: none !important;
}

.edit-modal-inner .variable-card {
  display: block !important;
}

.edit-modal-inner .variable-card-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.edit-modal-inner .variable-card-body {
  display: block !important;
}

.dispatch-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 12px 32px;
  border-bottom: 1px solid #eceef4;
  background: #fafbfd;
}

.new-dispatch-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(var(--theme-primaria));
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  transition: background 0.15s, opacity 0.15s;
  white-space: nowrap;
}

.new-dispatch-btn:hover {
  opacity: 0.9;
}

.new-dispatch-btn:active {
  opacity: 0.8;
}

.new-dispatch-btn i {
  font-size: 14px;
}

.dispatch-description {
  display: inline-block;
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #666;
  font-size: 13px;
}

.field-group {
  display: block;
  margin-bottom: 24px;
}

.field-group > label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  color: #333;
}

.variables-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
}

.variables-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.variables-hint {
  display: block;
  background: #f5f8ff;
  border: 1px solid #dde6ff;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 12px;
  color: #445;
  margin-bottom: 16px;
  line-height: 1.5;
}

.variables-hint code {
  background: #fff;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #dde6ff;
  font-family: Menlo, Consolas, monospace;
  font-size: 11px;
}

/* Inputs planos (sem Vuetify) — previsíveis e 100% width */
.plain-input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #d5d9e0;
  border-radius: 6px;
  background: #fff;
  color: #222;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.plain-input:focus {
  border-color: rgba(var(--theme-primaria));
  box-shadow: 0 0 0 2px rgba(73, 110, 186, 0.15);
}

.plain-input:disabled {
  background: #f3f4f7;
  color: #888;
  cursor: not-allowed;
}

.plain-textarea {
  min-height: 56px;
  resize: vertical;
  line-height: 1.4;
}

select.plain-input {
  appearance: auto;
  height: 36px;
}

/* Lista vertical dos cards */
.variables-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.variable-card {
  display: block;
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 12px;
}

.variable-add-card {
  margin-top: 4px;
}

.variable-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8f9fc;
  border-bottom: 1px solid #e6e8ef;
}

.variable-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.variable-card-key {
  font-family: Menlo, Consolas, monospace;
  font-size: 13px;
  font-weight: 600;
  color: #2a4365;
  padding: 3px 8px;
  background: #e6efff;
  border-radius: 4px;
}

.variable-card-new {
  font-style: italic;
  color: #888;
  font-size: 13px;
}

.variable-remove-btn {
  background: transparent;
  border: none;
  color: #a44;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 14px;
}

.variable-remove-btn:hover {
  background: #fdeaea;
}

.variable-card-body {
  display: block;
  padding: 14px;
}

/* Grid para a primeira linha (Chave / Rótulo / Tipo / Obrig) */
.variable-grid {
  display: grid;
  grid-template-columns: 1fr 1.3fr 1fr 0.6fr;
  gap: 12px;
  margin-bottom: 12px;
}

.variable-field {
  display: block;
  min-width: 0;
}

.key-field {
  position: relative;
}

.key-suggestions-floating {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #d5d9e0;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* max-height é injetado dinamicamente via :style */
}

.suggestions-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.suggestions-hint {
  padding: 6px 10px;
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  background: #f8f9fc;
  border-bottom: 1px solid #eceef4;
}

.suggestion-item {
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f0f2f7;
  transition: background 0.1s;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background: #f5f8ff;
}

.suggestion-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
}

.suggestion-key {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #2a4365;
  background: #e6efff;
  padding: 2px 6px;
  border-radius: 3px;
}

.suggestion-type {
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.suggestion-label {
  font-size: 12px;
  color: #333;
  line-height: 1.3;
  text-transform: none;
  letter-spacing: 0;
  font-weight: normal;
  margin-bottom: 2px;
}

.suggestion-usedin {
  font-size: 10px;
  color: #999;
  text-transform: none;
  letter-spacing: 0;
  font-weight: normal;
}

.variable-field + .variable-field-full {
  margin-top: 10px;
}

.variable-field label {
  display: block;
  font-size: 11px;
  color: #666;
  margin-bottom: 5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.variable-field-full {
  display: block;
  width: 100%;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 0;
  cursor: pointer;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0;
  font-weight: normal;
  color: #333;
  margin: 0;
}

.checkbox-wrapper input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin: 0;
}

.variable-add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 18px;
  border: 2px dashed #cfd6e0;
  background: transparent;
  border-radius: 8px;
  color: #778;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.variable-add-card:hover {
  border-color: #8aa6e0;
  color: #2a4365;
  background: #f5f8ff;
}

.variable-add-card i {
  font-size: 16px;
}

.empty-variables {
  display: block;
  padding: 30px 20px;
  text-align: center;
  color: #888;
  font-style: italic;
  background: #fafbfd;
  border: 1px dashed #d9dde5;
  border-radius: 6px;
}

/* Responsivo: abaixo de 700px, grid vira 1 coluna */
@media (max-width: 700px) {
  .variable-grid {
    grid-template-columns: 1fr;
  }
}
</style>
